import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '首届重庆市“吃得文明”主题活动公益广告创作大赛';

const route: RouteConfig = {
  path: '/20200401GYGG',
  name: 'GYGG',
  component: () => import('./Home.vue'),
  redirect: '/20200401GYGG/list',
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'list',
      component: () => import('./List.vue'),
      name: '20200401GYGG/list',
      meta: {
        title: PAGE_TITLE,
      },
      children: [
        {
          path: ':dataSource',
          component: () => import('./List.vue'),
          name: '20200401GYGG/source',
          meta: {
            title: PAGE_TITLE,
          },
        },
      ],
    },

    {
      path: 'register',
      component: () => import('./Register.vue'),
      name: '20200401GYGG/register',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detail',
      component: () => import('./Detail.vue'),
      name: '20200401GYGG/Detail',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rules',
      component: () => import('./Rules.vue'),
      name: '20200401GYGG/rules',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
